<template>

  <div id="pop-tan" class="pop-tan" v-show="pre_show">
    <!-- <div class="pop-tan-bg" @click="closeshow()"></div> -->
	<div class="pop-tan-bg" ></div>

    <div id="pop_body" class="pop-tan-content">
      <!-- 动态查询区生成 -->
      <div class="pop-tan_children">
        <div class="pop-tan-head-close">
          <a class="close" href="javascript:void(0);" @click="closeshow()"></a>
        </div>
        <div class="pop-tan-head-body">
          <slot name="tancontent">
            <!-- 只弹窗 -->
          </slot>
        </div>

      </div>

    </div>
  </div>


</template>

<script>
  /*
纯粹的弹窗
flex 弹窗 内容，布局有变化。会在重绘后，界面移动的现象！ add 2022-04-12
*/

  export default {
    name: "pre_tan",
    data() {
      return {
        element_loading: false,

        screenWidth: '',
        screenHeight: '',

        pre_show: false

      };
    },
    methods: {
      showpop: function(parm) {
        this.pre_show = true;
        var Hg = $(document).height();
        // 设置背景高度
        $(".pop-tan-bg").height(Hg);
        // 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
        $(".pop-tan-bg").fadeIn("3000");
        $(".pop-tan-content").fadeIn("3000");
        // console.log('111111111');
        this.chang_style();
      },
      closeshow: function() {

        this.pre_show = false;
        $(".pop-tan-bg").fadeOut("3000");
        $(".pop-tan-content").fadeOut("3000");
        this.screenHeight = 0;
        this.screenWidth = 0;
      },
      chang_style: function() {
        this.$nextTick(function() {
          this.screenWidth = $(window).width();
          this.screenHeight = $(window).height(); //当前浏览器窗口的 宽高
          var scrolltop = $(document).scrollTop(); //获取当前窗口距离页面顶部高度
          // console.log('屏宽='+this.screenWidth+' 屏高='+this.screenHeight);

        });
      }





    }
  };
</script>


<style scoped>
  .pop-tan {
    position: fixed;
    left: 0;
    top: 100px;
    width: 100vw;
    height: auto;
    /* border: 1px solid #ccc; */
    z-index: 30;
    display: flex;
    justify-content: center;
    align-items: stretch;
  }

  .pop-tan-bg {
    width: 100vw;
    background: #000000;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    display: none;
    z-index: 99;
  }

  .pop-tan-content {
    height: auto;
    /* background: #faf5f5; */
    background-color: rgb(195, 219, 250);
    position: fixed;
    border-radius: 3px;
    display: none;
    z-index: 999;
    /* padding: 5px; */
    overflow: hidden;

    display: inline-block;
    /* min-width: 932px; */
    max-height: 80vh;
	max-width: 90%;
    overflow: auto;
    box-shadow: 0 0 5px 5px #04567f;
  }

  .pop-tan_children {
    display: inline-flex;
    flex-direction: column;
    background-color: aliceblue;
    background: rgb(195, 219, 250);
    padding: 20px;
    border-radius: 5px;
  }

  .pop-tan-head-close {
    color: #b4b4b4;
    cursor: pointer;
    font-weight: normal;
    text-align: right;
    display: inline-flex;
    justify-content: flex-end;
    margin-top: -20px;
    margin-right: -20px;

  }




  .pop-tan-head-body {
    display: inline-flex;
    flex-direction: column;
    min-width: 200px;
    min-height: 200px;

    /* max-width: 80vw; */
    /* overflow: auto; */
  }
</style>
